(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["liquid-glass-styles"] && !Shopify.designMode) return;
  try {
    const filterGroups = [
    {
      title: 'Gender',
      type: 'multi',
      parameter: 'filter.p.tag',
      options: [
        ['Men', 'Men'],
        ['Women', 'Women'],
        ['Unisex', 'Unisex'],
      ],
    },
    {
      title: 'Shop by price',
      type: 'price',
      options: [
        ['under-50', 'Under £50', '', '49.99'],
        ['50-100', '£50 - £100', '50', '100'],
        ['100-150', '£100 - £150', '100', '150'],
        ['over-150', 'Over £150', '150.01', ''],
      ],
    },
    {
      title: 'Sale & Offers',
      type: 'multi',
      parameter: 'filter.p.tag',
      options: [['Sale', 'Sales']],
    },
    {
      title: 'Size',
      type: 'multi',
      parameter: 'filter.v.option.size',
      options: [
        ['XS', 'XS'],
        ['S', 'S'],
        ['M', 'M'],
        ['L', 'L'],
        ['XL', 'XL'],
        ['2XL', 'XXL'],
        ['3XL', '3XL'],
        ['4XL', '4XL'],
      ],
    },
  ];

  const selectedValues = (parameters, name) => {
    return parameters
      .getAll(name)
      .flatMap((value) => value.split(','))
      .filter(Boolean);
  };

  const isPriceSelected = (parameters, minimum, maximum) => {
    return parameters.get('filter.v.price.gte') === minimum && parameters.get('filter.v.price.lte') === maximum;
  };

  const checkboxMarkup = (group, option, index) => {
    const parameters = new URLSearchParams(window.location.search);
    const [value, label, minimum = '', maximum = ''] = option;
    const checked = group.type === 'price'
      ? isPriceSelected(parameters, minimum, maximum)
      : selectedValues(parameters, group.parameter).includes(value);
    const inputName = group.type === 'price' ? 'vo-price-filter' : group.parameter;

    return `<label class="vo-shop-filter__option">
      <input type="checkbox" name="${inputName}" value="${value}" data-filter-type="${group.type}" data-parameter="${group.parameter || ''}" data-minimum="${minimum}" data-maximum="${maximum}" ${checked ? 'checked' : ''}>
      <span class="vo-shop-filter__box" aria-hidden="true"></span>
      <span>${label}</span>
    </label>`;
  };

  const filterMenuMarkup = () => {
    const groups = filterGroups.map((group, groupIndex) => {
      const options = group.options.map((option, optionIndex) => checkboxMarkup(group, option, `${groupIndex}-${optionIndex}`)).join('');
      return `<section class="vo-shop-filter__group">
        <h3 class="vo-shop-filter__heading">${group.title}</h3>
        <div class="vo-shop-filter__options">${options}</div>
      </section>`;
    }).join('');

    return `<details class="vo-shop-filter">
      <summary class="vo-shop-filter__summary">Filter <span class="vo-shop-filter__count" data-count="0"></span></summary>
      <div class="vo-shop-filter__panel">${groups}<button class="vo-shop-filter__clear" type="button">Clear filters</button></div>
    </details>`;
  };

  const updateCount = (menu) => {
    const count = menu.querySelectorAll('input:checked').length;
    menu.querySelector('.vo-shop-filter__count').dataset.count = String(count);
  };

  const applyFilter = (input) => {
    const parameters = new URLSearchParams(window.location.search);

    if (input.dataset.filterType === 'price') {
      parameters.delete('filter.v.price.gte');
      parameters.delete('filter.v.price.lte');
      if (input.checked) {
        if (input.dataset.minimum) parameters.set('filter.v.price.gte', input.dataset.minimum);
        if (input.dataset.maximum) parameters.set('filter.v.price.lte', input.dataset.maximum);
      }
    } else {
      const name = input.dataset.parameter;
      const values = new Set(selectedValues(parameters, name));
      if (input.checked) values.add(input.value);
      else values.delete(input.value);
      parameters.delete(name);
      if (values.size) parameters.set(name, Array.from(values).join(','));
    }

    parameters.delete('page');
    window.location.search = parameters.toString();
  };

  const customiseSorting = (component) => {
    const allowed = new Map([
      ['manual', 'Featured'],
      ['best-selling', 'Featured'],
      ['created-descending', 'Newest'],
      ['price-ascending', 'Price: Low - High'],
      ['price-descending', 'Price: High - Low'],
    ]);
    let featuredFound = false;

    component.querySelectorAll('option').forEach((option) => {
      if (!allowed.has(option.value) || (allowed.get(option.value) === 'Featured' && featuredFound)) {
        option.remove();
        return;
      }
      option.textContent = allowed.get(option.value);
      if (allowed.get(option.value) === 'Featured') featuredFound = true;
    });

    featuredFound = false;
    component.querySelectorAll('.sorting-filter__option').forEach((option) => {
      const input = option.querySelector('input');
      const label = option.querySelector('.sorting-filter__label');
      if (!input || !allowed.has(input.value) || (allowed.get(input.value) === 'Featured' && featuredFound)) {
        option.closest('label')?.remove();
        return;
      }
      label.textContent = allowed.get(input.value);
      input.dataset.optionName = allowed.get(input.value);
      if (allowed.get(input.value) === 'Featured') featuredFound = true;
    });
  };

  const initialiseShopControls = () => {
    document.querySelectorAll('sorting-filter-component').forEach((component) => {
      customiseSorting(component);
      if (component.querySelector('.vo-shop-filter')) return;
      component.insertAdjacentHTML('afterbegin', filterMenuMarkup());
      const menu = component.querySelector('.vo-shop-filter');
      updateCount(menu);

      menu.addEventListener('change', (event) => {
        if (!(event.target instanceof HTMLInputElement)) return;
        if (event.target.dataset.filterType === 'price' && event.target.checked) {
          menu.querySelectorAll('input[data-filter-type="price"]').forEach((input) => {
            if (input !== event.target) input.checked = false;
          });
        }
        updateCount(menu);
        applyFilter(event.target);
      });

      menu.querySelector('.vo-shop-filter__clear').addEventListener('click', () => {
        const parameters = new URLSearchParams(window.location.search);
        ['filter.p.tag', 'filter.v.option.size', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((name) => parameters.delete(name));
        parameters.delete('page');
        window.location.search = parameters.toString();
      });
    });
  };

  initialiseShopControls();
  document.addEventListener('shopify:section:load', initialiseShopControls);

  const heartIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>';

  const customerContext = document.querySelector('#vo-customer-context');
  const favouritesKey = customerContext ? `vo-favourites-${customerContext.dataset.customerId}` : '';
  const readFavourites = () => {
    if (!favouritesKey) return [];
    try { return JSON.parse(localStorage.getItem(favouritesKey) || '[]'); }
    catch (error) { return []; }
  };
  const writeFavourites = (items) => localStorage.setItem(favouritesKey, JSON.stringify(items));

  const productDetails = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const image = card.querySelector('img');
    const title = (link.getAttribute('aria-label') || link.textContent || image?.alt || 'Product').trim();
    return { id: link.pathname, title, url: link.href, image: image?.currentSrc || image?.src || '' };
  };

  const updateFavouriteUI = () => {
    const items = readFavourites();
    document.querySelectorAll('.vo-favourites-count').forEach((count) => {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
    document.querySelectorAll('.vo-product-favourite').forEach((button) => {
      const details = productDetails(button.closest('product-card'));
      button.setAttribute('aria-pressed', String(Boolean(details && items.some((item) => item.id === details.id))));
    });
    document.querySelectorAll('[data-cart-favourite]').forEach((button) => {
      button.setAttribute('aria-pressed', String(items.some((item) => item.id === button.dataset.favouriteId)));
    });
  };

  const renderFavouritesPanel = () => {
    const panel = document.querySelector('.vo-favourites-panel');
    if (!panel) return;
    const list = panel.querySelector('.vo-favourites-list');
    const items = readFavourites();
    list.innerHTML = items.length ? items.map((item) => `<div class="vo-favourite-row">
      ${item.image ? `<img src="${item.image}" alt="" loading="lazy">` : '<span></span>'}
      <a href="${item.url}">${item.title}</a>
      <button type="button" data-remove-favourite="${item.id}" aria-label="Remove ${item.title} from favourites">×</button>
    </div>`).join('') : '<p class="vo-favourites-panel__empty">Your favourite items will appear here.</p>';
  };

  const initialiseHeaderActions = () => {
    document.querySelectorAll('#header-component .search-action button').forEach((button) => {
      if (!button.querySelector('.vo-search-label')) button.insertAdjacentHTML('beforeend', '<span class="vo-search-label">Search</span>');
    });

    document.querySelectorAll('#header-component .account-button__text').forEach((label) => {
      label.textContent = 'Sign In';
      label.classList.add('vo-sign-in-label');
      label.classList.remove('hidden', 'mobile:hidden');
    });

    if (!customerContext) return;
    document.querySelectorAll('#header-component header-actions').forEach((actions) => {
      if (actions.querySelector('.vo-favourites-action')) return;
      actions.insertAdjacentHTML('afterbegin', `<button type="button" class="vo-favourites-action" aria-label="Favourites" aria-expanded="false">${heartIcon}<span class="vo-favourites-count" hidden></span></button>`);
    });

    if (!document.querySelector('.vo-favourites-panel')) {
      document.body.insertAdjacentHTML('beforeend', '<aside class="vo-favourites-panel" hidden aria-label="Favourite items"><div class="vo-favourites-panel__top"><h2>Favourites</h2><button type="button" class="vo-favourites-panel__close" aria-label="Close favourites">×</button></div><div class="vo-favourites-list"></div></aside>');
    }

    document.querySelectorAll('product-card').forEach((card) => {
      const content = card.querySelector('.product-card__content');
      if (!content || content.querySelector('.vo-product-favourite') || !productDetails(card)) return;
      content.insertAdjacentHTML('afterbegin', `<button type="button" class="vo-product-favourite" aria-label="Add to favourites" aria-pressed="false">${heartIcon}</button>`);
    });
    updateFavouriteUI();
  };

  document.addEventListener('click', (event) => {
    const headerButton = event.target.closest('.vo-favourites-action');
    const panel = document.querySelector('.vo-favourites-panel');
    if (headerButton && panel) {
      const opening = panel.hidden;
      panel.hidden = !opening;
      headerButton.setAttribute('aria-expanded', String(opening));
      if (opening) renderFavouritesPanel();
      return;
    }
    if (event.target.closest('.vo-favourites-panel__close') && panel) {
      panel.hidden = true;
      document.querySelector('.vo-favourites-action')?.setAttribute('aria-expanded', 'false');
      return;
    }
    const productButton = event.target.closest('.vo-product-favourite');
    if (productButton) {
      event.preventDefault();
      event.stopPropagation();
      const details = productDetails(productButton.closest('product-card'));
      if (!details) return;
      const items = readFavourites();
      const index = items.findIndex((item) => item.id === details.id);
      if (index >= 0) items.splice(index, 1);
      else items.push(details);
      writeFavourites(items);
      updateFavouriteUI();
      renderFavouritesPanel();
      return;
    }
    const cartFavouriteButton = event.target.closest('[data-cart-favourite]');
    if (cartFavouriteButton && favouritesKey) {
      event.preventDefault();
      const details = {
        id: cartFavouriteButton.dataset.favouriteId,
        title: cartFavouriteButton.dataset.favouriteTitle,
        url: cartFavouriteButton.dataset.favouriteUrl,
        image: cartFavouriteButton.dataset.favouriteImage || '',
      };
      const items = readFavourites();
      const index = items.findIndex((item) => item.id === details.id);
      if (index >= 0) items.splice(index, 1);
      else items.push(details);
      writeFavourites(items);
      updateFavouriteUI();
      renderFavouritesPanel();
      return;
    }
    const removeButton = event.target.closest('[data-remove-favourite]');
    if (removeButton) {
      writeFavourites(readFavourites().filter((item) => item.id !== removeButton.dataset.removeFavourite));
      updateFavouriteUI();
      renderFavouritesPanel();
    }
  });

  const closeHeaderFlyouts = ({ returnFocus = false, except = null } = {}) => {
    const favouritesPanel = document.querySelector('.vo-favourites-panel');
    const favouritesTrigger = document.querySelector('.vo-favourites-action');
    if (favouritesPanel && !favouritesPanel.hidden && !favouritesPanel.contains(except) && !favouritesTrigger?.contains(except)) {
      favouritesPanel.hidden = true;
      favouritesTrigger?.setAttribute('aria-expanded', 'false');
      if (returnFocus) favouritesTrigger?.focus();
    }

    document.querySelectorAll('#header-component details[open]').forEach((menu) => {
      if (menu.contains(except)) return;
      const trigger = menu.querySelector('summary');
      menu.removeAttribute('open');
      trigger?.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger?.focus();
    });

    document.querySelectorAll('#search-modal[open], .search-modal__content[open]').forEach((dialog) => {
      if (dialog.contains(except)) return;
      if (typeof dialog.close === 'function') dialog.close();
    });
  };

  document.addEventListener('pointerdown', (event) => closeHeaderFlyouts({ except: event.target }));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeHeaderFlyouts({ returnFocus: true });
  });
  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('#search-modal[open], .search-modal__content[open]');
    if (dialog && event.target === dialog && typeof dialog.close === 'function') dialog.close();
  });

  initialiseHeaderActions();
  document.addEventListener('shopify:section:load', initialiseHeaderActions);
  } catch(e) { console.error(e); }
})();

})();
